<template>
  <FormItemWrapper
    :borderless="true"
    width="170px"
  >
    <el-select
      v-model="value"
      value-key="value"
      placeholder="Select"
      class="LanguageSelector"
    >
      <template slot="prefix">
        <img
          :src="require(`@/assets/img/flags/${value.flag}`)"
          width="24px"
          style="margin-top: 8px"
        >
      </template>
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item"
      >
        <img
          :src="require(`@/assets/img/flags/${item.flag}`)"
          width="24px" > {{ item.label }}
      </el-option>
    </el-select>
  </FormItemWrapper>
</template>

<script>
import Vue from 'vue';
import { Select, Option } from 'element-ui';
// Components
import FormItemWrapper from '@/components/formItem/Wrapper.vue';
import FormItemLabel from '@/components/formItem/Label.vue';
import Tooltip from '@/components/Tooltip.vue';

Vue.use(Select);
Vue.use(Option);

export default {
  name: 'LanguageSelector',
  components: {
    FormItemWrapper,
    FormItemLabel,
    Tooltip,
  },
  data() {
    return {
      options: [
        {
          value: '1',
          label: 'English',
          flag: 'USA.png',
          lang: 'en',
        },
        {
          value: '2',
          label: 'Crnogorski',
          flag: 'Montenegro.png',
          lang: 'cg',
        },
      ],
      value: null,
    };
  },
  watch: {
    value(value) {
      this.$i18n.set(value.lang);
      localStorage.setItem('language', value.lang);
    },
  },
  created() {
    this.setInitialValue();
  },
  methods: {
    setInitialValue() {
      const storedLanguage = localStorage.getItem('language');
      this.options.forEach((i) => {
        if (i.lang === storedLanguage) {
          this.value = i;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.LanguageSelector /deep/ .el-input--prefix .el-input__inner {
  padding-left: 35px;
}
.LanguageSelector /deep/ .el-select .el-input__prefix {
  // left: 10px;
}
</style>
